module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "h7"
    }
  }, [_vm._v("Coppicing")])]), _c('a', {
    attrs: {
      "id": "h7"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "h7"
    }
  }, [_vm._v("At the dissolution of Roche Abbey in 1538, when the woods on the Maltby side of the manor and parish boundary were sold by King Henry VIII to Henry Tyrrell, gentleman, they were managed on the coppice-with-standards system, with a regular cycle of fellings."), _c('sup')]), _c('a', {
    attrs: {
      "id": "fn2-5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" It seems likely that the King’s Wood on the opposite bank of the boundary stream was also managed in this way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Sandbeck Estate Archives provide only occasional information about King’s Wood after the dissolution, but enough records survive to provide a general picture of changing uses. A survey of ‘Roche wood’ in 1593 complained of poor management, but showed that at least some of the oaks were grown for timber, that the wood was divided into falls, and that the summer grazing of ten horses was allowed in part. One complaint of the surveyors was that the wood was ‘unfenced & unsevered from the common which was in tymes paste walled rounde’. The verdict of the jury that was empanelled at Tickhill found that ‘there hath bene great spoile of woode & three hundrethe Timber Ockes sould by Mr Eyre’, the lessee."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the seventeenth and eighteenth centuries, the principal use of the woodlands throughout the South Yorkshire lowlands, extending from the magnesian limestone belt on to the extensive coal-measure sandstones and shales, was to supply timber and coppice fuel for the local charcoal iron industry. In 1719, for example, the felling of extensive woodlands on the estate belonging to the Duke of Leeds around Harthill, Anston, Wales, Lindrick, Todwick and Kiveton Park raised £15,000. The estates of gentry families in other magnesian limestone townships at Dinnington, Gildingwells, Edlington, Wadworth and Sprotbrough also supplied large amounts of timber and underwood. Amongst the most magnificent woods were those of the Scarbrough estate in and around Maltby, which in 1724 covered 770 acres."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The great value of these woods encouraged the leading ironmasters of south-west Yorkshire - William Simpson and Francis Barlow (two Sheffield attorneys who owned Chapel Furnace and Attercliffe Forge) and Dennis Hayford of Wortley Forge - to build a forge at Stone, just downstream from Roche Abbey, well to the east of their ironstone mines. On 20 April 1681 these three ironmasters purchased 2,170 ‘Oake, Ash or other Trees’ in Sandbeck Park and adjoining places, including Grange Wood and Hell Wood and hedgerows, ‘alsoe one hundred yews in Sandbecke Parke’, to ‘stubb & carrie away Together with the bark Topps bodyes roots boughs Timber cord wood & Ramill’."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stone Forge or the Roche Abbey Forge, as it was known alternatively, was one of the smaller ones, with an annual production of sixty tons of pig iron. It probably did not last beyond the mid-eighteenth century and in 1802 it was converted into a corn mill."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" The industrial demand for charcoal fell sharply when coke became the established fuel. In the nineteenth century coppicing declined and the woods were valued more for their timber and for the cover they provided for game, particularly pheasants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Accounts of regular, but small sales of timber to local builders or joiners and carpenters survive from the middle years of the nineteenth century. On 27 February 1851, for instance, Isaac Allsop of Worksop, a regular customer, bought ‘776 feet of Lime Tree from King’s Wood’, for £32.6s.8d., together with small purchases of yew, elm, dutch elm, and cherry. In the same year, another regular customer, Joseph Garside of Worksop, bought ‘708 feet of Oak from King’s Wood’, with other oaks, ash, elm, beech, dutch elm, birch and ‘syrup’, which seems to have been sycamore. Accounts that survive for 1878–98 show a similar modest annual return from sales under the direction of a woodman."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By far the most informative document for our purposes in the Sandbeck Estate Archives is a printed catalogue headed:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("To Sell by Auction on Thursday the 23rd Day of June 1870, At the Scarbrough Arms Inn, Tickhill, The Following Valuable Lots of Timber and Poles, Living in King’s Wood, Numbered and Crossed with a Scrieve Iron. Most of the Lots are of large dimension, and well grown. The Beech and Limes are adapted for the Sheffield trade, and other Manufacturing purpose, and the whole well worth the attention of Timber Merchants, Colliery Owners, Contractors, Wheelwrights, Carpenters, &c."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The reference to ‘the Sheffield trade’ is explained by the common use of beech for a variety of tool handles and of lime for the wooden patterns to make the moulds for cast iron decorative fireplaces, such as those manufactured by Hoole’s Green Lane Works."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sale was divided into sixteen lots, with no striking variation between the mixture of trees in each lot and no specialised compartments. In most cases these are listed in two columns, giving the totals of each type of tree. The first columns are headed ‘numbered trees’ and the second ‘crossed poles’, suitable for coopers, fencing and crate makers, or for making bobbins. The overall totals for the numbered trees are: Oak 235, Ash 54, Elm 134, Lime 197, Beech 95, Holly 10, Crab 2, Service 16, Maple 6, Cherry 4, Mountain Ash 1, Birch 17. Those for the crossed poles are: Oak 278, Ash 185, Elm 425, Lime 124, Beech 18, Holly 35, Thorn 19, Maple 81, Cherry 7, Mountain Ash 34, Service 23, Birch 18, Crab 4. Of course, we do not know how many trees were left unmarked or were not for sale, nor whether all the above trees and poles were actually sold. No yews were felled and it is noticeable that sycamores receive no mention. Nevertheless, this list of trees indicates an assemblage with very much the same basic character as the woodland today, essentially of the semi-natural type characteristic of this terrain. The value of the information contained in such notices of auction is immediately apparent; they are a prime source for woodland historians to establish the character of a wood in the Victorian period and to relate it to what survives today.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c3b3bca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/18_chapter024.vue
// module id = 111
// module chunks = 0